import { shape, string } from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

import { withDocumentTitle } from '../generic/DocumentTitle';
import Titled from '../layout/Titled';
import api from '../REST/api';
import DeleteButton from '../REST/DeleteButton';
import update from '../REST/update';
import { tapFlashSuccess } from '../utils/flash';
import BrandForm from './BrandForm';
import {
  getTransformedBrand,
  transformForPatch,
  transformForRendering,
} from './transform-brand-helpers';

const UpdateBrandForm = update({
  query: getTransformedBrand,
  deriveQueryArgs: ({ id }) => ({ id }),
  update: ({ id }, changedModel) =>
    api
      .patchBrand({
        id,
        data: transformForPatch(changedModel),
      })
      .then(transformForRendering)
      .then(tapFlashSuccess('Brand update successful')),
  form: withDocumentTitle(({ model }) => model.name)(BrandForm),
  redirectTo: '/brands/:id/show',
});

function UpdateBrand({ match }) {
  const id = Number.parseInt(match.params.id, 10);

  return (
    <Titled
      title="Edit Brand"
      actions={[
        <DeleteButton
          onDelete={api.destroyBrand}
          id={id}
          name="Brand"
          redirectTo="/brands"
        />,
        <Link to="show" className="btn btn-secondary ml-2">
          Show
        </Link>,
      ]}
      sticky
    >
      <UpdateBrandForm id={id} />
    </Titled>
  );
}

UpdateBrand.propTypes = {
  match: shape({ params: shape({ id: string.isRequired }).isRequired })
    .isRequired,
};

export default UpdateBrand;
